/* -------------------------------------------------------------------------- */
/*                           Schema Countries                                 */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const country = new schema.Entity('countries', {}, { idAttribute: 'countryId' });
export const countries = new schema.Array(country);
